import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const useUpsertRouterConfig = () => {
  const [
    upsertRouterConfigMutation,
    {
      error: upsertRouterError,
      data: upsertResponseData,
      loading: upsertRouterLoading,
    },
  ] = useMutation<
    GraphQLTypes.UpdateRouterConfigMutation,
    GraphQLTypes.UpdateRouterConfigMutationVariables
  >(gql`
    mutation UpdateRouterConfigMutation(
      $graphId: ID!
      $variant: String!
      $newRouterConfig: String!
    ) {
      service(id: $graphId) {
        variant(name: $variant) {
          upsertRouterConfig(configuration: $newRouterConfig) {
            ... on RouterUpsertFailure {
              message
            }
          }
        }
      }
    }
  `);

  const upsertRouterConfig = useCallback(
    async ({
      graphId,
      variant,
      newRouterConfig,
    }: GraphQLTypes.UpdateRouterConfigMutationVariables) => {
      return upsertRouterConfigMutation({
        variables: {
          graphId,
          variant,
          newRouterConfig,
        },
        update: (cache) => {
          cache.evict({
            id: cache.identify({
              __typename: 'Service',
              id: graphId,
            }),
            fieldName: 'variant',
          });
        },
      });
    },
    [upsertRouterConfigMutation],
  );

  return {
    upsertRouterError,
    upsertResponseData,
    upsertRouterLoading,
    upsertRouterConfig,
  };
};
